import { render } from "./BlogSidebarFullMouthRest.vue?vue&type=template&id=00f4f710"
import script from "./BlogSidebarFullMouthRest.vue?vue&type=script&lang=js"
export * from "./BlogSidebarFullMouthRest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__